import { useEffect } from 'react';

/**
 * Hook that registers a global keyboard shortcut (Alt/Option + P) to toggle audio play/pause.
 *
 * @param onToggle - Callback function to execute when the shortcut is triggered
 */
export const useAudioPlayPauseShortcut = (onToggle: () => void): void => {
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.altKey && e.code === 'KeyP') {
				e.preventDefault();
				onToggle();
			}
		};

		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [onToggle]);
};
